"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommonController = /** @class */ (function () {
    function CommonController() {
        this.isDatePickerOpen = false;
    }
    CommonController.prototype.openDateTime = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        this.isDatePickerOpen = true;
    };
    return CommonController;
}());
exports.CommonController = CommonController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmNvbnRyb2xsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb21tb24uY29udHJvbGxlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBO0lBQUE7UUFDVyxxQkFBZ0IsR0FBWSxLQUFLLENBQUM7SUFRN0MsQ0FBQztJQU5VLHVDQUFZLEdBQW5CLFVBQW9CLE1BQU07UUFDdEIsTUFBTSxDQUFDLGNBQWMsRUFBRSxDQUFDO1FBQ3hCLE1BQU0sQ0FBQyxlQUFlLEVBQUUsQ0FBQztRQUV6QixJQUFJLENBQUMsZ0JBQWdCLEdBQUcsSUFBSSxDQUFDO0lBQ2pDLENBQUM7SUFDTCx1QkFBQztBQUFELENBQUMsQUFURCxJQVNDO0FBVFksNENBQWdCIn0=